<template>
    <div>
        <div class="fpx">
            <img src="../assets/fpx-dir.png" alt='loading'></img>
        </div>
        <el-card class="box-card">
            <div class="card-inner">
                <el-card class="sub-box-card">
                    <div class="card-text">
                        <span class="row2">{{message}}</span>
                        <br/>
                        <span class="row3">Kindly click on the "Back to Merchant" button.</span>
                    </div>
                    <div>
                        <el-button class="button-b" @click="link">
                            <sapn class="button-text">Back to Merchant({{toTime}}s)</sapn>
                        </el-button>
                    </div>
                </el-card>
            </div>
        </el-card>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                toTime: 10,
                message: ''
            }
        },

        beforeCreate() {
            let info = window.location.hash;
            let start = info.indexOf("info=");
            if (start == -1) {
                this.$router.replace({ name: '/NotFound' })
                return;
            } else {
                let Base64 = require('js-base64').Base64
                info = info.slice(start + 5);
                try {
                    info = decodeURIComponent(info);
                    info = Base64.decode(info)
                    info = JSON.parse(info)
                } catch (error) {
                    this.$router.replace({ name: '/NotFound' })
                    return;
                };
                let journalNo = info.journalNo;
                if (journalNo == undefined || journalNo == null) {
                    journalNo = "";
                }
                window.sessionStorage.setItem('journalNo', journalNo)
                window.sessionStorage.setItem('reasonCode', info.reasonCode)
                window.sessionStorage.setItem('arMessage', info.reasonCodeDesc)
            }
        },

        created() {
            window.sessionStorage.setItem('statusCode', "error")
            this.message = window.sessionStorage.getItem('arMessage');
            window.sessionStorage.setItem('message', 'Payment unsuccessful and you have log out.')
            let taskid = setInterval(() => {
                if (this.toTime > 1) {
                    this.toTime--;
                } else {
                    clearInterval(taskid);
                    this.link();
                }
            }, 1000);
        },

        methods: {
            link() {
                this.$router.replace({
                    name: 'ReturnToFpx',
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    @media screen and (max-width: 330px) {
        @import "../styles/mobile-i/m_error-page.less";
    }

    @media screen and (min-width: 331px) and (max-width: 370px) {
        @import "../styles/mobile/m_error-page.less";
    }

    @media screen and (min-width: 371px) and (max-width: 400px) {
        @import "../styles/mobile_b/m_error-page.less";
    }

    @media screen and (min-width: 401px) and (max-width: 640px) {
        @import "../styles/mobile_p/m_error-page.less";
    }

    @media screen and (min-width: 641px) and (max-width: 800px) {
        @import "../styles/pad/error-page.less";
    }

    @media screen and (min-width: 801px) and (max-width: 1200px) {
        @import "../styles/pad_pro/error-page.less";
    }

    @media screen and (min-width: 1201px) {
        @import "../styles/pc/error-page.less";
    }
</style>


// WEBPACK FOOTER //
// src/views/SysError.vue